/**
 * 运输台账相关接口
 */
import request from '../utils/axios'

/**
 * 获取当前用户运输台账列表
 * @param {number} pageNumber
 * @param {number} pageSize
 * @returns
 */
export function getMyTransportList(data) {
  return request({
    url: "/TransportLedger/GetMyList",
    method: "POST",
    data: data
  })
}

/**
 * 工作人员获取运输台账所有数据
 * @param {*} data
 * {
 *  "pageNumber": 1,
 *  "pageSize": 10,
 *  "keyword": "string",
 *  "orderbyType": 0,
 *  "isOrder": true
 * }
 * @returns
 */
export function getAllTransportList(data) {
  return request({
    url: "/TransportLedger/GetAllList",
    method: "POST",
    data: data
  })
}
/**
 * 根据ID删除台账记录
 * @param {*} id
 * @returns
 */
export function deleteTransportById(id) {
  return request({
    url: `/TransportLedger/Delete?id=${id}`,
    method: "GET",
  })
}
/**
 * 根据ID获取台账详情
 * @param {*} id
 * @returns
 */
export function getTransportDetailById(id) {
  return request({
    url: `/TransportLedger/GetDetails?id=${id}`,
    method: "GET",
  })
}

/**
 * 更新运输台账
 * @param {*} id
 * @returns
 */
export function updateTransportAccount(data) {
  return request({
    url: `/TransportLedger/Update`,
    method: "POST",
		data: data
  })
}

/**
 * 地图模式获取列表（工作人员）
 */
export function GetAllListForMap() {
  return request({
    url: '/TransportLedger/GetAllListForMap',
    method: "GET",
  })
}

/**
 * 获取本年度每月采伐量(运输方量)
 */
export function GetMonthlyTransportCapacityCount() {
  return request({
    url: '/TransportLedger/GetMonthlyTransportCapacityCount',
    method: "GET",
  })
}

/**
 * 获取林木溯源模块统计(工作人员)
 */
export function GetLmsyCount() {
  return request({
    url: '/TransportLedger/GetLmsyCount',
    method: "get",
  })
}